const convertDateFormat = (inputDate) => {
  // yyyy-mm-dd to e.g. January 1, 2023
  const dateObject = new Date(inputDate+ " "); // space added because it forces UTC for creation
  
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const month = monthNames[dateObject.getMonth()];
  const day = dateObject.getDate();
  const year = dateObject.getFullYear();
  const formattedDate = `${month} ${day}, ${year}`;
  return formattedDate;
};

export { convertDateFormat };
